import styled, { css } from 'styled-components';

import { CarouselTitleStyles } from '~/components/shared/core/carousel/styles';
import { S as RecommendationsS } from '~/components/shared/recommendations/styles';
import { CONTAINER_ID, TITLE_ID } from '~/components/shared/recommendations/stylitics/constants';

export const S = {
  // Extends the wrapper of the other recommendation carousels, so the title and the outfit
  // cards follow the same --recommendation-margin at every breakpoint.
  RecommendationsWrapper: styled(RecommendationsS.RecommendationsWrapper)<{
    $discountColor?: string | null;
  }>`
    ${({ theme, $discountColor }) => css`
      --stylitics-ui-card-background: ${theme.colors.cream['100']};
      --stylitics-ui-icon-plus-circle-fill: ${theme.colors.cream['100']};
      --stylitics-ui-border: unset;
      --stylitics-ui-border-radius: 0;
      --stylitics-ui-price-color: ${theme.colors.content.primary};
      --stylitics-ui-sale-price-color: ${$discountColor || theme.colors.content.primary};
      --stylitics-ui-font-family: ${({ theme }) => theme.font.family.primary}, Arial, Helvetica,
        sans-serif;
      --stylitics-ui-carousel-padding: 0 var(--recommendation-margin);

      .stylitics-hotspots-widget-base {
        padding-bottom: ${theme.padding.lg};
      }

      #${TITLE_ID} {
        ${CarouselTitleStyles}
      }

      #${CONTAINER_ID} {
        scroll-margin-top: ${theme.padding['2xl']};

        .stylitics-hotspots-layout {
          margin: 0;
        }

        .stylitics-ui-card-face {
          border: unset;
          border-radius: 0;
        }

        .stylitics-ui-carousel-inner {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .stylitics-ui-card {
          --stylitics-ui-card-border-size: 0px;
        }

        .stylitics-hotspots-outfit-cta {
          display: none;
        }

        .stylitics-hotspots-item-label {
          padding: ${theme.padding['3xs']} ${theme.padding['2xs']};
          background: white;
          backdrop-filter: unset;
          box-shadow: 0 4px 6px -2px rgba(33 37 41 / 5%), 0 12px 16px -4px rgba(33 37 41 / 10%);
          cursor: pointer;

          [class*='stylitics-icon-size'] {
            display: none;
          }
        }

        .stylitics-hotspots-label-texts {
          padding: 0;
          max-width: 135px;
          gap: 0;
          align-items: center;
          text-align: center;
        }

        .stylitics-hotspots-label-brand,
        .stylitics-hotspots-label-name,
        .stylitics-ui-price {
          --stylitics-ui-price-font-size: ${theme.font.size['2']};

          color: ${theme.colors.content.primary};
          font-size: ${theme.font.size['2']};
          line-height: 1.4;
          text-decoration: none;
        }

        .stylitics-ui-price {
          font-weight: ${theme.variables.font.weight.bold};
        }

        .stylitics-ui-regular-price-slashed {
          font-weight: ${theme.variables.font.weight.medium};
          color: ${theme.colors.content.secondary};
        }

        .stylitics-ui-icon-plus,
        .stylitics-hotspots-dot {
          height: ${theme.font.size['7']};
          width: ${theme.font.size['7']};
        }

        .stylitics-hotspots-dot {
          background: rgba(0 0 0 / 10%);
          box-shadow: 0 0 0 2px rgba(0 0 0 / 10%);
          border-radius: 68px;
        }

        .stylitics-ui-icon-plus * {
          stroke: white;
          stroke-width: 2px;
        }

        .stylitics-hotspots-dot-focus-area {
          border-radius: 68px;
          border: 1px solid rgba(255 255 255 / 10%);
          background: rgba(255 255 255 / 0%);
          box-shadow: 0 2px 4px -2px rgba(0 0 0 / 5%), 0 0 8px -2px rgba(0 0 0 / 5%);
          margin: -2px;
          padding: 2px;
        }

        .stylitics-ui-icon-plus-circle {
          fill: transparent;
          r: 9px;
        }

        .stylitics-ui-arrow-button {
          --stylitics-ui-arrow-button-background-color: ${theme.colors.background.component[
            'carousel-arrow'
          ].rest};
          --stylitics-ui-arrow-button-icon-stroke: ${theme.colors.content.inverse};
          --stylitics-ui-arrow-button-border-radius: 1px;
          --stylitics-ui-arrow-button-size: ${theme.size['10']};

          &:hover,
          &:focus {
            background-color: ${theme.colors.background.component['carousel-arrow'].hover};
          }

          &.stylitics-next {
            right: 0 !important;
          }

          &.stylitics-previous {
            left: 0 !important;
          }

          svg {
            height: 17px;
            width: 9px;
          }
        }

        .stylitics-bundle-badge {
          left: ${theme.padding['3xs']};
          text-align: left;
          top: ${theme.padding['3xs']};
          cursor: default;
        }
      }
    `}
  `,
  RecommendationsContainer: styled.div``,
  QuickViewWrapper: styled.div`
    display: none;
  `,
};
